import type { Control } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "~/components/ui/form";
import { Input } from "~/components/ui/input";

interface SalesCategory {
  name: string;
}

export const SalesCategoryNameField = ({
  control,
  disabled,
}: {
  control: Control<SalesCategory>;
  disabled?: boolean;
}) => {
  return (
    <FormField
      control={control}
      name="name"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Name</FormLabel>
          <FormControl>
            <Input
              {...field}
              disabled={disabled}
              placeholder="Food, Beverages, Alcohol..."
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
